/** Shared layout tokens for multi-filter toolbars across list/audit pages. */

export const PAGE_FILTER_CONTROL_HEIGHT = 40;

export const pageFilterInputRootSx = {
  height: PAGE_FILTER_CONTROL_HEIGHT,
};

export const pageFiltersToolbarSx = {
  mb: 2,
};

export const pageFiltersStackSx = {
  direction: { xs: 'column', lg: 'row' },
  spacing: 1,
  alignItems: { xs: 'stretch', lg: 'flex-start' },
  justifyContent: 'space-between',
};

export const pageFiltersControlsSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  alignItems: 'flex-end',
  flex: 1,
  minWidth: 0,
  width: '100%',
};

export const pageFiltersActionsSx = {
  display: 'flex',
  gap: 1,
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  alignSelf: { lg: 'flex-start' },
  justifyContent: { xs: 'flex-start', lg: 'flex-end' },
  flexShrink: 0,
  width: { xs: '100%', lg: 'auto' },
};

export const pageFilterAutocompleteSx = (minWidth = 200) => ({
  minWidth: { xs: '100%', sm: minWidth },
  width: { xs: '100%', sm: 'auto' },
  flex: { xs: '1 1 100%', sm: '0 0 auto' },
  '& .MuiInputBase-root': pageFilterInputRootSx,
});

export const pageFilterFormControlSx = (minWidth = 160) => ({
  minWidth: { xs: 0, sm: minWidth },
  width: { xs: '100%', sm: 'auto' },
  flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 auto' },
  '& .MuiInputBase-root': pageFilterInputRootSx,
});

export const pageFilterDatePickerSx = (minWidth = 180) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  height: PAGE_FILTER_CONTROL_HEIGHT,
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.23)',
  borderRadius: 1,
  px: 1.25,
  cursor: 'pointer',
  minWidth: { xs: '100%', sm: minWidth },
  width: { xs: '100%', sm: 'auto' },
  flex: { xs: '1 1 100%', sm: '0 0 auto' },
  '&:hover': {
    borderColor: 'rgba(0, 0, 0, 0.87)',
  },
});

export const pageFilterActionButtonSx = {
  textTransform: 'none',
  height: PAGE_FILTER_CONTROL_HEIGHT,
  minWidth: 'auto',
  px: 1.5,
  fontSize: '0.875rem',
  whiteSpace: 'nowrap',
};
